import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, ContentChildren, InputSignal, QueryList, input } from '@angular/core';
import { SimplifiedListItemComponent } from './item/simplified-list-item.component';

@Component({
  selector: 'td-wb-simplified-list',
  templateUrl: './simplified-list.component.html',
  styleUrls: ['./simplified-list.component.scss'],
  imports: [
    NgTemplateOutlet
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimplifiedListComponent {
  readonly ariaLabel: InputSignal<string | undefined> = input<string | undefined>(undefined, { alias: 'aria-label' });
  readonly ariaLabelledBy: InputSignal<string | undefined> = input<string | undefined>(undefined, { alias: 'aria-labelledby' });
  @ContentChildren(SimplifiedListItemComponent) readonly items: QueryList<SimplifiedListItemComponent>;
}
